import gql from 'graphql-tag';
import { categoryFieldsFragment } from './categoryFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';
import { evaluationSummaryFieldsFragment } from './evaluationSummaryFieldsFragment';

export const evaluationFieldsFragment = gql`
  fragment AdminEvaluationFields on Evaluation {
    ...AdminEvaluationSummaryFields
    totalMaxTime
    options {
      enableTimer
    }
    rCategories {
      ...AdminCategoryFields
    }
    rQuestions {
      ...AdminQuestionFields
    }
    archived
  }

  ${evaluationSummaryFieldsFragment}
  ${categoryFieldsFragment}
  ${questionFieldsFragment}
`;
